// https://stackoverflow.com/a/51529486
const language = ["en", "et", "fi", "sv"] as const;
export type Language = typeof language[number];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isSupportedLang = (x: any): x is Language => language.includes(x);

// Cookie settings taken from stv-utils
const COOKIE_NAME = "used_ui_language";
const COOKIE_LIFETIME = 60 * 60 * 24 * 1000; // 1000 days
// If not in localhost, strip "rp." from the hostname.
const { hostname } = window.location;
const COOKIE_DOMAIN =
  hostname.indexOf("rp.") === 0 ? hostname.slice("rp.".length) : hostname;
const DEFAULT_LANG: Language = "fi";

export const setCookieLang = (lang: Language) => {
  document.cookie = `used_ui_language=${lang}; path=/; domain=${COOKIE_DOMAIN}; max-age=${COOKIE_LIFETIME}; samesite=None; secure`;
};

export const getLang = (): Language => {
  return getCookieLang() || getBrowserLang() || DEFAULT_LANG;
};

const getCookieLang = (): Language | undefined => {
  return document.cookie
    .split(";")
    .reduce((lang: Language | undefined, cookie) => {
      const [key, value] = cookie.split("=").map(s => s.trim());
      if (key === COOKIE_NAME && isSupportedLang(value)) {
        lang = value;
      }
      return lang;
    }, undefined);
};

const getBrowserLang = (): Language | undefined => {
  return language.find(lang => navigator.language.indexOf(lang) === 0);
};

export { default as RPFormattedMessage } from "@src/i18n/RPFormattedMessage";
export { default as IntlProviderBoundary } from "@src/i18n/IntlProviderBoundary";
